import Platform from '../Platform'
export default class App extends Platform {
  constructor () {
    super({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      platform: 'desktop',
      supportedInsertFileTypes: ['svg'],
      features: {
        localStorage: true,
        prototype: false,
        messages: false,
        fillType: false,
        syncFromTool: false
      }
    })
  }

  init () {
    // Set Platform for Backend tracking
    let platform = null

    if (window.electronIs.windows()) {
      platform = 'win'
    } else if (window.electronIs.osx()) {
      platform = 'osx'
    } else if (window.electronIs.linux()) {
      platform = 'linux'
    }
    this.platform += `-${platform}`

    // Listen to Settings
    window.ipcRenderer.on('settings', (event, arg) => {
      window.store.commit('settings/setAutoLaunch', arg.autolaunch)
    })

    window.ipcRenderer.send('fetchAutoLaunch')
  }

  // file = { format, name, url }
  insertItem (file) {
    console.log('insertItem', file)
    this.download(file, `~/Downloads`)
  }

  insertItems (files) {
    console.log('insertItems', files[0])
    this.download(files[0], `~/Downloads`)
  }

  download (url, path = null) {
    window.ipcRenderer.send('download', url, path)
  }

  dragstart (url) {
    console.log('dragstart', url)
    window.ipcRenderer.send('dragstart', url)
  }

  openURL (url) {
    window.ipcRenderer.send('openURL', url)
  }

  setAutoLaunch (value) {
    window.ipcRenderer.send('setAutoLaunch', value)
  }

  quit () {
    window.ipcRenderer.send('quit')
  }
}
